import { CatHeading } from '@blocks-react/components/Heading';
import { CustomerAccountSelectedEquipmentHeadingProps } from '../../types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { useMemo } from 'react';
import { CustomStyledLabel } from '../../../request-service';
import { CatTextPassage } from '@blocks-react/components/TextPassage';

export const CustomerAccountSelectedEquipmentHeading = ({
  children,
  showTooltip = true,
  className,
  ...headingProps
}: CustomerAccountSelectedEquipmentHeadingProps) => {
  const label = useMemo(() => {
    const headingClass = showTooltip ? 'text-truncate d-block' : '';
    return (
      <CatHeading slot="trigger" {...headingProps}>
        <CustomStyledLabel>
          <span className={headingClass}>{children}</span>
        </CustomStyledLabel>
      </CatHeading>
    );
  }, [children, headingProps, showTooltip]);
  return (
    <div className={className}>
      {showTooltip ? (
        <CatTooltip position="auto">
          {label}
          <CatTextPassage>{children}</CatTextPassage>
        </CatTooltip>
      ) : (
        <>{label}</>
      )}
    </div>
  );
};
